// shared/components/modal.ts — <app-modal>
// Modal de confirmación reutilizable.

export class AppModal extends HTMLElement {
  private _onConfirm: (() => void) | null = null;

  static define() { customElements.define('app-modal', AppModal); }

  connectedCallback() { this.render(); }

  open(opts: { title: string; body: string; confirmLabel: string; danger?: boolean; onConfirm: () => void }) {
    this._onConfirm = opts.onConfirm;
    const overlay  = this.querySelector<HTMLElement>('.modal-overlay')!;
    const title    = this.querySelector<HTMLElement>('.modal-title')!;
    const body     = this.querySelector<HTMLElement>('.modal-body')!;
    const confirmBtn = this.querySelector<HTMLButtonElement>('.modal-confirm')!;

    title.textContent     = opts.title;
    body.textContent      = opts.body;
    confirmBtn.textContent = opts.confirmLabel;
    confirmBtn.style.setProperty(
      '--btn-bg',
      opts.danger ? 'var(--color-error)' : 'var(--color-primary)'
    );
    overlay.classList.add('active');
  }

  close() {
    this.querySelector('.modal-overlay')?.classList.remove('active');
    this._onConfirm = null;
  }

  private render() {
    this.innerHTML = `
      <style>
        .modal-overlay {
          position: fixed; inset: 0;
          background: rgba(0,0,0,.7);
          backdrop-filter: blur(4px);
          z-index: var(--z-modal);
          display: flex; align-items: center; justify-content: center;
          opacity: 0; pointer-events: none;
          transition: opacity var(--duration-normal) var(--ease-standard);
        }
        .modal-overlay.active { opacity: 1; pointer-events: auto; }
        .modal-box {
          background: var(--color-surface);
          border: 1px solid var(--color-border);
          border-radius: var(--radius-xl);
          padding: var(--space-6);
          width: 90%; max-width: 340px;
          transform: translateY(20px);
          transition: transform var(--duration-normal) var(--ease-decelerate);
          box-shadow: var(--shadow-xl);
        }
        .modal-overlay.active .modal-box { transform: translateY(0); }
        .modal-title { font-family: var(--font-display); font-size: var(--text-lg); font-weight: var(--font-weight-bold); margin-bottom: var(--space-2); }
        .modal-body  { font-size: var(--text-sm); color: var(--color-text-muted); margin-bottom: var(--space-6); line-height: var(--leading-relaxed); }
        .modal-actions { display: flex; gap: var(--space-3); justify-content: flex-end; }
        button {
          font-family: var(--font-body);
          border-radius: var(--radius-md); padding: var(--space-2) var(--space-4);
          font-size: var(--text-sm); font-weight: var(--font-weight-semibold);
          cursor: pointer; border: none; transition: opacity var(--duration-fast);
        }
        button:hover { opacity: .85; }
        .modal-cancel  { background: var(--color-surface-raised); color: var(--color-text-muted); border: 1px solid var(--color-border); }
        .modal-confirm { background: var(--btn-bg, var(--color-primary)); color: var(--color-primary-text); }
      </style>
      <div class="modal-overlay">
        <div class="modal-box">
          <p class="modal-title"></p>
          <p class="modal-body"></p>
          <div class="modal-actions">
            <button class="modal-cancel">Cancelar</button>
            <button class="modal-confirm">Confirmar</button>
          </div>
        </div>
      </div>
    `;

    this.querySelector('.modal-cancel')!.addEventListener('click', () => this.close());
    this.querySelector('.modal-confirm')!.addEventListener('click', () => {
      this._onConfirm?.();
      this.close();
    });
    this.querySelector('.modal-overlay')!.addEventListener('click', (e) => {
      if (e.target === e.currentTarget) this.close();
    });
  }
}
